import React from 'react';
import harvardIcon from "../../../assets/icons/workIcons/harvardIcon.svg";

function HarvardIcon() {
    return ( 
        <img className="tab-icon" src={harvardIcon} alt="harvardIcon.svg"/>
    );
}

export default HarvardIcon;